/**
 * Journal add-to-cart → mini-cart flyout
 * Handles .js-jr-add-form submits and exposes window.jrAddToCart for kit rail.
 */
;(() => {
  if (window.__jrCartBound) return
  window.__jrCartBound = true

  async function jrAddToCart(items) {
    const itemsArray = Array.isArray(items) ? items : [items]
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: itemsArray }),
    })
    if (!response.ok) {
      throw new Error(await response.text())
    }
    document.dispatchEvent(
      new CustomEvent('nova:cart:refresh', {
        bubbles: true,
        composed: true,
      }),
    )
    document.dispatchEvent(
      new CustomEvent('nova:cart:open', { bubbles: true }),
    )
  }

  window.jrAddToCart = jrAddToCart

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target?.closest?.('.js-jr-add-form')
      if (!form) return
      event.preventDefault()

      const btn = form.querySelector('[type="submit"]')
      const idInput = form.querySelector('input[name="id"]')
      const qtyInput = form.querySelector('input[name="quantity"]')
      const id = idInput?.value
      if (!id || btn?.disabled) return

      const quantity = Number(qtyInput?.value || 1) || 1
      const label = btn.textContent
      btn.disabled = true
      btn.textContent = 'Adding…'

      try {
        await jrAddToCart([{ id: Number(id), quantity }])
        btn.textContent = 'Added ✓'
        setTimeout(() => {
          btn.textContent = label
          btn.disabled = false
        }, 1400)
      } catch (error) {
        console.error(error)
        btn.textContent = 'Try again'
        btn.disabled = false
        setTimeout(() => {
          btn.textContent = label
        }, 1600)
      }
    },
    true,
  )
})()
